module.exports = require("./ka.d.ts");